import { render, staticRenderFns } from "./DuplicateShift.vue?vue&type=template&id=559b4b28&"
import script from "./DuplicateShift.vue?vue&type=script&setup=true&lang=ts&"
export * from "./DuplicateShift.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports